import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@app/app';

import './styles/index.scss';

const container = document.querySelector('#root');
if (container) {
	const root = createRoot(container);
	root.render(<App />);
}
